import React from "react";

const CookiesSummarySnippet = () => (
  <p>
    We use necessary cookies and similar technologies to make UNBL work. We'd
    also like to use these to guide how we make improvements, by recording how
    you use the site. These will be set only if you accept.
  </p>
);

export default CookiesSummarySnippet;
